import { render, staticRenderFns } from "./PrintErgebnisliste.vue?vue&type=template&id=34329d13&scoped=true"
import script from "./PrintErgebnisliste.vue?vue&type=script&lang=js"
export * from "./PrintErgebnisliste.vue?vue&type=script&lang=js"
import style0 from "./PrintErgebnisliste.vue?vue&type=style&index=0&id=34329d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34329d13",
  null
  
)

export default component.exports